const groupPrefix = createApiRoute(ApiModule.PRODUCTION_PLANNING, ApiAuthorization.EMPLOYEE, ApiDataModel.EMPLOYEES)

export const apiActivityLogs = {
	fetchEmployeeActivityLogs: async (
		employeeId: number,
		page: number = 1,
		perPage: number = DEFAULT_PAGE_SIZE,
		filters?: IActivityLogFilters,
	) => {
		const { data, meta } = await apiCommon<IActivityLog[]>(
			`${groupPrefix}/${employeeId}/${ApiDataModel.ACITVITY_LOGS}`,
			{
				method: 'GET',
				...createQuery({ page, perPage }, null, undefined, {
					action: filters?.action,
					module: filters?.module,
					from: filters?.from,
					to: filters?.to,
				}),
			},
		)

		return { data: data.map(ActivityLog), meta }
	},
}
